import { PermissionsEnum } from '@/auth/interfaces';
import { SaveMotivoRechazo } from '../../shared/saveMotivoRechazo/';
import { useCheckPermissions } from '@/shared';

export interface CreateMotivoRechazoPageInterface {}

const CreateMotivoRechazoPage: React.FC<CreateMotivoRechazoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_motivorechazo)
  return <SaveMotivoRechazo titlePage="Crear Motivos de rechazo" />;
};

export default CreateMotivoRechazoPage;
